module.exports = __webpack_public_path__ + "img/donante-centro-ericksoniano.5aa02b5b.png";